module.exports = __webpack_public_path__ + "img/votre_plus_beau_marche.1036638d.jpg";